import BrCode from '../../lib/br_code';
import QRCode from 'qrcode';

const QR_CODE_SIZE = 400;

export default class EmvQR {
  static code({ key, amount, name, reference, key_type, city }) {
    if (key) {
      let brCode = new BrCode(key, amount, name, reference, key_type, city),
        code = brCode.generate_qrcp();

      return QRCode.toDataURL(code, { width: QR_CODE_SIZE, height: QR_CODE_SIZE })
        .then((qrcode) => {
          return {
            qrcode_base64: qrcode,
            code: code,
            key_type: brCode.key_type,
            key: brCode.key,
            amount: brCode.amount,
            name: brCode.name,
            city: brCode.city,
            reference: brCode.reference,
            formated_amount: brCode.formated_amount()
          }
        }).catch(err => {
          console.error(err);
        });
    } else {
      console.error('Campo Key não presente');
    }
  }
}